import React from 'react';
import { Form, Radio } from 'antd';
import { useIntl } from 'react-intl';

import styles from './styles.module.scss';

export type PaymentPlanCardsProps = {
  onPlanChange: (plan: 'full' | 'instalments') => void;
};

export function PaymentPlanCards({ onPlanChange }: PaymentPlanCardsProps): React.ReactElement {
  const intl = useIntl();

  return (
    <Form.Item name="paymentPlan" className={styles.formItem}>
      <Radio.Group className={styles.planGroup} onChange={(e) => onPlanChange(e.target.value)}>
        <Radio value="full" className={styles.planCard}>
          <span className={styles.planLabel}>
            {intl.formatMessage({ id: 'certificates.payment.payInFull' })}
          </span>
        </Radio>
        <Radio value="instalments" className={styles.planCard}>
          <span className={styles.planLabel}>
            {intl.formatMessage({ id: 'certificates.payment.installments' })}
          </span>
        </Radio>
      </Radio.Group>
    </Form.Item>
  );
}
